import styled from 'styled-components';

const Main = styled.div`
   margin-top: 50px;
   margin-bottom: 80px;
`;

const Table = (props) => {
    return (
     <Main>
          <table className="min-w-full divide-y  table-fixed">
                <tbody className="divide-y ">
                        {props.td2 !==void 0 && 
                            <tr className="">
                                <td className="py-4 p-1 text-sm font-medium  whitespace-nowrap text-center">{props.td1}</td>
                                <td className="py-4 p-1 text-sm font-medium  border-l-2 whitespace-nowrap ">{props.td2}</td>
                            </tr>
                        }
                        {props.td4 !==void 0 && 
                            <tr className="">
                                <td className="py-4 p-1 text-sm font-medium  whitespace-nowrap text-center">{props.td3}</td>
                                <td className="py-4 p-1 text-sm font-medium  border-l-2 whitespace-nowrap ">
                                {props.td4}{props.td4_1 !==void 0 && <p>{props.td4_1}</p>}
                                </td>
                            </tr>
                        }
                        {props.td6 !==void 0 && 
                            <tr className="">
                                <td className="py-4 p-1 text-sm font-medium  whitespace-nowrap text-center">{props.td5}</td>
                                <td className="py-4 p-1 text-sm font-medium  border-l-2 whitespace-nowrap ">
                                    {props.td6}{props.td6_1 !==void 0 && <p>{props.td6_1}</p>}
                                </td>
                            </tr>
                        }
                        {props.td8 !==void 0 && 
                        <tr className="">
                            <td className="py-4 p-1 text-sm font-medium  whitespace-nowrap text-center">{props.td7}</td>
                            <td className="py-4 p-1 text-sm font-medium border-l-2 whitespace-nowrap ">{props.td8}</td>
                        </tr>
                        }
                        {props.td10 !==void 0 && 
                            <tr className="">
                                <td className="py-4 p-1 text-sm font-medium  whitespace-nowrap text-center">{props.td9}</td>
                                <td className="py-4 p-1 text-sm font-medium border-l-2 whitespace-nowrap ">{props.td10}</td>
                            </tr>
                        }
                        {props.td12 !==void 0 && 
                        <tr className="">
                            <td className="py-4 p-1 text-sm font-medium  whitespace-nowrap text-center">{props.td11}</td>
                            <td className="py-4 p-1 text-sm font-medium border-l-2 whitespace-nowrap ">{props.td12}</td>
                        </tr>
                        }
                        {props.td14 !==void 0 && 
                        <tr className="">
                            <td className="py-4 p-1 text-sm font-medium  whitespace-nowrap text-center">{props.td13}</td>
                            <td className="py-4 p-1 text-sm font-medium border-l-2 whitespace-nowrap ">{props.td14}</td>
                        </tr>
                        }
                </tbody>
        </table>
     </Main>
       
    );
}

export default Table;